import { userPermissionsEnum } from '../../../Core/Users/enums/user-permissions.enum';
import { NavItem, NavItemType } from '../../../Common/Layout/components/Navbar/navbar.component';
import { ResearchRequestDialogComponent } from '../../../Common/Dialogs/components/ResearchRequestDialog/research-request-dialog.component';
import { G2ReviewDialogComponent } from '../../../Common/Dialogs/components/G2ReviewDialog/g2-review-dialog.component';

export const supportNav: NavItem[] = [
    {
        label: 'Core.navigation.support.supportAndTraining',
        icon: 'fa-duotone fa-regular fa-headset',
        id: 'primaryNavSupportAndTraining',
        items: [
            {
                label: 'Core.navigation.support.contactSupport',
                type: NavItemType.contactSupport,
                id: 'primaryNavContactSupport'
            },
            {
                label: 'Core.navigation.support.supportLibrary',
                url: 'https://www.agilitypr.com/support/',
                id: 'primaryNavSupportLibrary'
            },
            {
                label: 'Core.navigation.support.submitRequest',
                type: NavItemType.dialog,
                permissions: [
                    userPermissionsEnum.targeting,
                    userPermissionsEnum.advancedTargeting
                ],
                dialogReference: ResearchRequestDialogComponent,
                id: 'primaryNavSubmitResearchRequest',
            }
        ]
    },
    {
        label: 'Core.navigation.support.usage',
        icon: 'fa-duotone fa-regular fa-file-shield',
        id: 'primaryNavUsage',
        items: [
            {
                label: 'Core.navigation.support.policy',
                url: 'https://www.agilitypr.com/privacy-policy/',
                id: 'primaryNavPolicy'
            },
            {
                label: 'Core.navigation.support.termsOfUse',
                url: 'https://www.agilitypr.com/agility/terms-us/',
                id: 'primaryNavTermsOfUse'
            }
        ]
    },
    {
        label: 'Core.navigation.support.agility',
        icon: 'fa-kit fa-agpr-agility',
        id: 'primaryNavAgility',
        items: [
            {
                label: 'Core.navigation.support.about',
                url: 'https://www.agilitypr.com/about-us/',
                id: 'primaryNavAbout'
            },
            {
                label: 'Core.navigation.support.products',
                url: 'https://www.agilitypr.com/our-solutions/',
                id: 'primaryNavProducts'
            },
            {
                label: 'Core.navigation.support.contact',
                url: 'https://www.agilitypr.com/contact/',
                id: 'primaryNavContact'
            },
            {
                label: 'Core.navigation.support.rss',
                url: 'https://www.agilitypr.com/feed/',
                id: 'primaryNavFeed'
            },
            {
                label: 'Core.navigation.support.review',
                type: NavItemType.takeOverPanel,
                dialogReference: G2ReviewDialogComponent,
                id: 'primaryNavReview'
            }
        ]
    }
];
